<template>
  <div class="empty-state">
    <div class="empty-state-illustration" aria-hidden="true">
      <img
        v-if="illustrationSrc"
        :src="illustrationSrc"
        alt=""
        class="empty-state-img"
      />
      <i v-else class="fas empty-state-icon" :class="iconClass"></i>
    </div>
    <p class="empty-state-message">{{ message }}</p>
    <slot name="default">
      <button
        v-if="ctaText"
        type="button"
        class="empty-state-cta"
        @click="$emit('cta-click')"
      >
        {{ ctaText }}
      </button>
    </slot>
  </div>
</template>

<script>
function illustrationPath(type) {
  const base = (process.env.BASE_URL || '/').replace(/\/?$/, '');
  return `${base}/illustrations/empty-${type}.svg`;
}

const TYPES = ['cruises', 'deals', 'alerts'];

export default {
  name: 'EmptyState',
  props: {
    type: {
      type: String,
      default: 'cruises',
      validator: (v) => TYPES.includes(v)
    },
    message: {
      type: String,
      required: true
    },
    ctaText: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    illustrationSrc() {
      return illustrationPath(this.type);
    },
    iconClass() {
      if (this.icon) return this.icon;
      const icons = { cruises: 'fa-ship', deals: 'fa-tag', alerts: 'fa-bell' };
      return icons[this.type] || 'fa-inbox';
    }
  }
};
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: var(--space-6);
  color: var(--color-text-muted);
  background: var(--cs-signal-mist);
  border-radius: var(--radius-lg);
}

.empty-state-illustration {
  margin-bottom: var(--space-5);
  color: var(--color-text-muted);
  opacity: 0.7;
}

.empty-state-img {
  width: 120px;
  height: 120px;
  max-width: 100%;
  object-fit: contain;
}

.empty-state-icon {
  font-size: 64px;
}

.empty-state-message {
  font-size: var(--text-body);
  margin: 0 0 var(--space-4);
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}

.empty-state-cta {
  min-height: var(--touch-min);
  padding: var(--space-3) var(--space-5);
  background-color: var(--cs-fill);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: background var(--transition-normal);
}

.empty-state-cta:hover {
  background-color: var(--cs-fill-hover);
}

.empty-state-cta:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}
</style>
